// extracted by mini-css-extract-plugin
module.exports = {"root":"hint_root__J5CDN","collapsed":"hint_collapsed__1s16c"};